import { FamilyUnit, PossibleEmployerContributionDto } from '@zorro/clients';

export const isChildlessFamilyUnit = (familyUnitItem: FamilyUnit): boolean => {
  return (
    familyUnitItem === FamilyUnit.EMPLOYEE_ONLY ||
    familyUnitItem === FamilyUnit.EMPLOYEE_SPOUSE
  );
};

export const filterContributionsByFamilyUnit = (
  contributions: PossibleEmployerContributionDto[],
  familyUnit: FamilyUnit
): PossibleEmployerContributionDto[] => {
  return contributions.filter((model) => model.familyUnit === familyUnit);
};

export const hasStipendRange = (
  contributions: PossibleEmployerContributionDto[]
): boolean => {
  if (contributions.length <= 1) return false;
  return (
    new Set(contributions.map((contribution) => contribution.stipend)).size > 1
  );
};

export const calculateStipends = (
  contributions: PossibleEmployerContributionDto[],
  isChildless: boolean
): { minimumStipend?: number; maximumStipend?: number } => {
  if (isChildless) {
    const contribution = contributions[0];
    return {
      minimumStipend: contribution?.stipend,
      maximumStipend: undefined,
    };
  }

  if (contributions.length === 0) {
    return { minimumStipend: undefined, maximumStipend: undefined };
  }

  const stipends = contributions.map((contribution) => contribution.stipend);

  return {
    minimumStipend: Math.min(...stipends),
    maximumStipend: Math.max(...stipends),
  };
};
